export type HolderNameSource = 'contact' | 'manual' | null

export interface WizardHolder {
  roleCode: string
  nameSource: HolderNameSource
  name: string
  contactId: string | null
  relationship?: string
}

export interface ContactOption {
  id: string
  name: string
  firstName?: string
  lastName?: string
  email?: string
}

export interface WizardAccount {
  accountRefId: string
  selection: Record<string, string>
  typeId: string
  holders: WizardHolder[]
  schemaSnapshot: Record<string, unknown>
  schemaFetchedAt?: string
  values: Record<string, unknown>
}

export const createEmptyAccount = (): WizardAccount => ({
  accountRefId: crypto.randomUUID(),
  selection: {},
  typeId: '',
  holders: [],
  schemaSnapshot: {},
  values: {},
})

export interface ItemPatch {
  values?: Record<string, unknown>
  holders?: WizardHolder[]
  selection?: Record<string, string>
  typeId?: string
}

export interface WizardParty {
  customerRefId: string
  name: string
  contactId: string | null
  roleCodes: string[]
  kycSchemaSnapshot: Record<string, unknown>
  kycValues: Record<string, unknown>
}

export interface WizardFormContext {
  missingFieldIds: Set<string>
  formData?: Record<string, unknown>
}

export interface WizardContext {
  accountId: string
  connector: string
  contactId: string | null
  roomId: string | null
  sessionId: string | null
  meetingTemplateId: string | null
}
